module.exports = __webpack_public_path__ + "static/img/documentation.250402ca.svg";